import { useState, useEffect } from 'react';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section[id]');
      const scrollY = window.pageYOffset;

      sections.forEach(section => {
        const sectionTop = section.offsetTop - 100;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          setActiveSection(sectionId);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (e, id) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({ top: el.offsetTop - 70, behavior: 'smooth' });
    }
  };

  const links = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'programs', label: 'Programs' },
    { id: 'impact', label: 'Impact' },
    { id: 'story', label: 'Our Story' },
    { id: 'get-involved', label: 'Get Involved' },
  ];

  return (
    <nav className="navbar">
      <div className="container nav-container">
        <a className="logo" href="#home" onClick={(e) => scrollTo(e, 'home')} style={{ textDecoration: 'none' }}>
          <span className="logo-bridge" role="img" aria-label="bridge">&#127753;</span>
          <span className="logo-text">Bridges to Learning</span>
        </a>
        <button
          className={`mobile-menu-toggle ${menuOpen ? 'active' : ''}`}
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          {links.map(link => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className={activeSection === link.id ? 'active' : ''}
                onClick={(e) => scrollTo(e, link.id)}
              >
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <a href="#donate" className="btn btn-primary btn-small" onClick={(e) => scrollTo(e, 'donate')}>
              Donate
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
